<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12 mb-4">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">{{ isEdicao ? 'Editar CNAE' : 'Novo CNAE' }}</h1>
            <p class="welcome-message">
              <button mat-icon-button (click)="voltar()"><mat-icon>arrow_back</mat-icon></button>
              Preencha os dados abaixo para {{ isEdicao ? 'editar' : 'cadastrar' }} o CNAE.
            </p>
          </div>
        </div>
      </div>
      @if (isLoading) {
        <div class="col-12">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4 mb-3">
              <app-loading-box [height]="'56'" [margin]="'0 0 22px 0'"></app-loading-box>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <app-loading-box [height]="'56'" [margin]="'0 0 22px 0'"></app-loading-box>
            </div>
          </div>
        </div>
      } @else {
        <div class="col-12">
          <form [formGroup]="form">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Código</mat-label>
                  <input
                    matInput
                    type="text"
                    inputmode="numeric"
                    formControlName="codigo"
                    [mask]="masks.cnae"
                    placeholder="0000-0/00"
                    required />
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    aria-label="Pesquisar CNAE"
                    matTooltip="Pesquisar CNAE"
                    (click)="pesquisarCnae()">
                    <mat-icon class="material-symbols-outlined">search</mat-icon>
                  </button>
                  <mat-hint class="hint-linha-inteira"
                    >Pesquise na base oficial de CNAEs ou informe um código e uma descrição
                    próprios.</mat-hint
                  >
                  @if (form.get('codigo')?.hasError('required')) {
                    <mat-error>O código é <strong>obrigatório</strong></mat-error>
                  } @else if (form.get('codigo')?.hasError('mask')) {
                    <mat-error>Informe o CNAE completo no formato 0000-0/00.</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Descrição</mat-label>
                  <input
                    matInput
                    formControlName="descricao"
                    placeholder="Digite a descrição do CNAE"
                    [maxlength]="tamanhoMaximoDescricao"
                    required />
                  <mat-hint align="end"
                    >{{ form.get('descricao')?.value?.length || 0 }} / {{ tamanhoMaximoDescricao }}</mat-hint
                  >
                  @if (form.get('descricao')?.hasError('required')) {
                    <mat-error>A descrição é <strong>obrigatória</strong></mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
</div>
<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()"></app-footer-action>
